import { render, staticRenderFns } from "./organ.vue?vue&type=template&id=55aa85b2&scoped=true&"
import script from "./organ.vue?vue&type=script&lang=js&"
export * from "./organ.vue?vue&type=script&lang=js&"
import style0 from "./organ.vue?vue&type=style&index=0&id=55aa85b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa85b2",
  null
  
)

export default component.exports